import { BTSelectItem } from "types/apiResponse/apiResponse";

import { type JobStatus } from "entity/job/Job.api.types";

interface IJobData {
    jobID: number;
    jobName: string;
    builderID: number;
    NewJobName: string;
    jobStatus: JobStatus;
}

interface IExistingJobListResponseData {
    jobs: IJobData[];
    footerData: unknown;
    records: number;
    infiniteScrollStatus: number;
    isLoaded: boolean;
    isTemplateMode: boolean;
}

export class Job extends BTSelectItem {
    constructor(data: IJobData) {
        super({ id: data.jobID, name: data.jobName });
        this.builderID = data.builderID;
        this.jobID = data.jobID;
        this.jobName = data.jobName;
        this.NewJobName = data.NewJobName;
        this.jobStatus = data.jobStatus;
    }

    builderID: number;
    jobID: number;
    jobName: string;
    NewJobName: string;
    jobStatus: JobStatus;
}

export class ExistingJobListResponse {
    constructor(data: IExistingJobListResponseData) {
        this.jobs = data.jobs.map((j) => new Job(j));
        this.footerData = data.footerData;
        this.records = data.records;
        this.infiniteScrollStatus = data.infiniteScrollStatus;
        this.isLoaded = data.isLoaded;
        this.isTemplateMode = data.isTemplateMode;
    }

    jobs: Job[];
    footerData: unknown;
    records: number;
    infiniteScrollStatus: number;
    isLoaded: boolean;
    isTemplateMode: boolean;
}
